<script lang="ts" setup>
import type { TRouteName } from "@/assets/js/globalTypes";
import { $t } from "@/i18n";

defineOptions({
	name: "admin",
});
definePage({
	name: "admin",
	path: "/admin",
	redirect: "/admin/schools",
	meta: {
		roleIds: [1],
	},
});

const route = useRoute("admin");

export type TSidebarItem = {
	name: TRouteName;
	links: { name: TRouteName; label: string }[];
};
const sidebarItems = computed<TSidebarItem[]>(() => [
	{
		name: "admin.schools",
		links: [],
	},
	{
		name: "admin.teachers",
		links: [
			{
				name: "admin.teachers.pending",
				label: $t("app.admin.sidebarNav.pendingValidation"),
			},
			{
				name: "admin.teachers.all",
				label: $t("app.admin.sidebarNav.allTeachers"),
			},
		],
	},
	{
		name: "admin.system",
		links: [
			{
				name: "admin.system.subjects",
				label: $t("app.admin.sidebarNav.subjects"),
			},
			{ name: "admin.system.skills", label: $t("app.admin.sidebarNav.skills") },
		],
	},
]);

const currentItem = computed(() => {
	for (const el of sidebarItems.value) {
		if (route.matched.some((el2) => el.name === el2.name)) {
			return el;
		}
	}
	return { name: "admin", links: [] } as TSidebarItem;
});
</script>
<template>
	<div id="admin-page">
		<admin-header-bar />
		<div class="content">
			<admin-side-bar :links="currentItem" />
			<router-view class="subpage"></router-view>
		</div>
	</div>
</template>

<style scoped lang="scss">
#admin-page {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	.content {
		flex: 1;
		display: flex;
		flex-wrap: nowrap;
		height: 100%;
	}
}
</style>
